import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { AuthService } from './core/services/auth/auth.service';
import { IdleTimeoutService } from './core/services/idle-timeout.service';
import { Observable, Subscription } from 'rxjs';
import { LoadingService } from './core/services/loading-services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  authUser: any;
  private authSubscription!: Subscription;
  loading$: Observable<boolean>;

  constructor(
    private authService: AuthService,
    private idleTimeoutService: IdleTimeoutService,
    private loadingService: LoadingService
  ) {
    this.loading$ = this.loadingService.loading$;
  }

  ngOnInit(): void {
    // First check if there's a stored token and initialize the auth state
    const storedUser = this.authService.getUserFromToken();
    console.log('User changed:', storedUser);
    if (storedUser) {
      this.authService.currentUserSubject.next(storedUser);
      this.idleTimeoutService.startWatching(); // Start idle timeout immediately if user exists
    }

    // Then set up subscription for future changes
    this.authSubscription = this.authService.currentUser$.subscribe((user) => {
      this.authUser = user; // Update local user reference
      console.log('User changed:', user);
      if (user) {
        console.log('User logged in, starting idle timeout');
        this.idleTimeoutService.startWatching();
      } else {
        console.log('User logged out, stopping idle timeout');
        this.idleTimeoutService.stopWatching();
      }
    });
  }

  ngOnDestroy() {
    this.idleTimeoutService.stopWatching();
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  title = 'halobiz-ui';
}
